export interface Municipio {
  codigo: number;
  nome: string;
  uf: string;
}

export interface Uf {
  nome: string;
  sigla: string;
  alias: string;
}

export const UFS: Uf[] = [
  { nome: 'Acre', sigla: 'AC', alias: 'acre' },
  { nome: 'Alagoas', sigla: 'AL', alias: 'alagoas' },
  { nome: 'Amapá', sigla: 'AP', alias: 'amapa' },
  { nome: 'Amazonas', sigla: 'AM', alias: 'amazonas' },
  { nome: 'Bahia', sigla: 'BA', alias: 'bahia' },
  { nome: 'Ceará', sigla: 'CE', alias: 'ceara' },
  { nome: 'Distrito Federal', sigla: 'DF', alias: 'distrito_federal' },
  { nome: 'Espírito Santo', sigla: 'ES', alias: 'espirito_santo' },
  { nome: 'Goiás', sigla: 'GO', alias: 'goias' },
  { nome: 'Maranhão', sigla: 'MA', alias: 'maranhao' },
  { nome: 'Mato Grosso', sigla: 'MT', alias: 'mato_grosso' },
  { nome: 'Mato Grosso do Sul', sigla: 'MS', alias: 'mato_grosso_do_sul' },
  { nome: 'Minas Gerais', sigla: 'MG', alias: 'minas_gerais' },
  { nome: 'Pará', sigla: 'PA', alias: 'para' },
  { nome: 'Paraíba', sigla: 'PB', alias: 'paraiba' },
  { nome: 'Paraná', sigla: 'PR', alias: 'parana' },
  { nome: 'Pernambuco', sigla: 'PE', alias: 'pernambuco' },
  { nome: 'Piauí', sigla: 'PI', alias: 'piaui' },
  { nome: 'Rio de Janeiro', sigla: 'RJ', alias: 'rio_de_janeiro' },
  { nome: 'Rio Grande do Norte', sigla: 'RN', alias: 'rio_grande_do_norte' },
  { nome: 'Rio Grande do Sul', sigla: 'RS', alias: 'rio_grande_do_sul' },
  { nome: 'Rondônia', sigla: 'RO', alias: 'rondonia' },
  { nome: 'Roraima', sigla: 'RR', alias: 'roraima' },
  { nome: 'Santa Catarina', sigla: 'SC', alias: 'santa_catarina' },
  { nome: 'São Paulo', sigla: 'SP', alias: 'sao_paulo' },
  { nome: 'Sergipe', sigla: 'SE', alias: 'sergipe' },
  { nome: 'Tocantins', sigla: 'TO', alias: 'tocantins' },
];

export const MUNICIPIOS: Municipio[] = [
  // Amazonas
  { codigo: 1300029, nome: 'Alvarães', uf: 'AM' },
  { codigo: 1300060, nome: 'Amaturá', uf: 'AM' },
  { codigo: 1300086, nome: 'Anamã', uf: 'AM' },
  { codigo: 1300102, nome: 'Anori', uf: 'AM' },
  { codigo: 1300144, nome: 'Apuí', uf: 'AM' },
  { codigo: 1300201, nome: 'Atalaia do Norte', uf: 'AM' },
  { codigo: 1300300, nome: 'Autazes', uf: 'AM' },
  { codigo: 1300409, nome: 'Barcelos', uf: 'AM' },
  { codigo: 1300508, nome: 'Barreirinha', uf: 'AM' },
  { codigo: 1300607, nome: 'Benjamin Constant', uf: 'AM' },
  { codigo: 1300631, nome: 'Beruri', uf: 'AM' },
  { codigo: 1300680, nome: 'Boa Vista do Ramos', uf: 'AM' },
  { codigo: 1300706, nome: 'Boca do Acre', uf: 'AM' },
  { codigo: 1300805, nome: 'Borba', uf: 'AM' },
  { codigo: 1300839, nome: 'Caapiranga', uf: 'AM' },
  { codigo: 1300904, nome: 'Canutama', uf: 'AM' },
  { codigo: 1301001, nome: 'Carauari', uf: 'AM' },
  { codigo: 1301100, nome: 'Careiro', uf: 'AM' },
  { codigo: 1301159, nome: 'Careiro da Várzea', uf: 'AM' },
  { codigo: 1301209, nome: 'Coari', uf: 'AM' },
  { codigo: 1301308, nome: 'Codajás', uf: 'AM' },
  { codigo: 1301407, nome: 'Eirunepé', uf: 'AM' },
  { codigo: 1301506, nome: 'Envira', uf: 'AM' },
  { codigo: 1301605, nome: 'Fonte Boa', uf: 'AM' },
  { codigo: 1301654, nome: 'Guajará', uf: 'AM' },
  { codigo: 1301704, nome: 'Humaitá', uf: 'AM' },
  { codigo: 1301803, nome: 'Ipixuna', uf: 'AM' },
  { codigo: 1301852, nome: 'Iranduba', uf: 'AM' },
  { codigo: 1301902, nome: 'Itacoatiara', uf: 'AM' },
  { codigo: 1301951, nome: 'Itamarati', uf: 'AM' },
  { codigo: 1302009, nome: 'Itapiranga', uf: 'AM' },
  { codigo: 1302108, nome: 'Japurá', uf: 'AM' },
  { codigo: 1302207, nome: 'Juruá', uf: 'AM' },
  { codigo: 1302306, nome: 'Jutaí', uf: 'AM' },
  { codigo: 1302405, nome: 'Lábrea', uf: 'AM' },
  { codigo: 1302504, nome: 'Manacapuru', uf: 'AM' },
  { codigo: 1302553, nome: 'Manaquiri', uf: 'AM' },
  { codigo: 1302603, nome: 'Manaus', uf: 'AM' },
  { codigo: 1302702, nome: 'Manicoré', uf: 'AM' },
  { codigo: 1302801, nome: 'Maraã', uf: 'AM' },
  { codigo: 1302900, nome: 'Maués', uf: 'AM' },
  { codigo: 1303007, nome: 'Nhamundá', uf: 'AM' },
  { codigo: 1303106, nome: 'Nova Olinda do Norte', uf: 'AM' },
  { codigo: 1303205, nome: 'Novo Airão', uf: 'AM' },
  { codigo: 1303304, nome: 'Novo Aripuanã', uf: 'AM' },
  { codigo: 1303403, nome: 'Parintins', uf: 'AM' },
  { codigo: 1303502, nome: 'Pauini', uf: 'AM' },
  { codigo: 1303536, nome: 'Presidente Figueiredo', uf: 'AM' },
  { codigo: 1303569, nome: 'Rio Preto da Eva', uf: 'AM' },
  { codigo: 1303601, nome: 'Santa Isabel do Rio Negro', uf: 'AM' },
  { codigo: 1303700, nome: 'Santo Antônio do Içá', uf: 'AM' },
  { codigo: 1303809, nome: 'São Gabriel da Cachoeira', uf: 'AM' },
  { codigo: 1303908, nome: 'São Paulo de Olivença', uf: 'AM' },
  { codigo: 1303957, nome: 'São Sebastião do Uatumã', uf: 'AM' },
  { codigo: 1304005, nome: 'Silves', uf: 'AM' },
  { codigo: 1304062, nome: 'Tabatinga', uf: 'AM' },
  { codigo: 1304104, nome: 'Tapauá', uf: 'AM' },
  { codigo: 1304203, nome: 'Tefé', uf: 'AM' },
  { codigo: 1304237, nome: 'Tonantins', uf: 'AM' },
  { codigo: 1304260, nome: 'Uarini', uf: 'AM' },
  { codigo: 1304302, nome: 'Urucará', uf: 'AM' },
  { codigo: 1304401, nome: 'Urucurituba', uf: 'AM' },

  // // Ceará
  // { codigo: 2300101, nome: 'Abaiara', uf: 'CE' },
  // { codigo: 2300150, nome: 'Acarape', uf: 'CE' },
  // { codigo: 2300200, nome: 'Acaraú', uf: 'CE' },
  // { codigo: 2300309, nome: 'Acopiara', uf: 'CE' },
  // { codigo: 2300408, nome: 'Aiuaba', uf: 'CE' },
  // { codigo: 2300507, nome: 'Alcântaras', uf: 'CE' },
  // { codigo: 2300606, nome: 'Altaneira', uf: 'CE' },
  // { codigo: 2300705, nome: 'Alto Santo', uf: 'CE' },
  // { codigo: 2300754, nome: 'Amontada', uf: 'CE' },
  // { codigo: 2300804, nome: 'Antonina do Norte', uf: 'CE' },
  // { codigo: 2300903, nome: 'Apuiarés', uf: 'CE' },
  // { codigo: 2301000, nome: 'Aquiraz', uf: 'CE' },
  // { codigo: 2301109, nome: 'Aracati', uf: 'CE' },
  // { codigo: 2301208, nome: 'Aracoiaba', uf: 'CE' },
  // { codigo: 2301257, nome: 'Ararendá', uf: 'CE' },
  // { codigo: 2301307, nome: 'Araripe', uf: 'CE' },
  // { codigo: 2301406, nome: 'Aratuba', uf: 'CE' },
  // { codigo: 2301505, nome: 'Arneiroz', uf: 'CE' },
  // { codigo: 2301604, nome: 'Assaré', uf: 'CE' },
  // { codigo: 2301703, nome: 'Aurora', uf: 'CE' },
  // { codigo: 2301802, nome: 'Baixio', uf: 'CE' },
  // { codigo: 2301851, nome: 'Banabuiú', uf: 'CE' },
  // { codigo: 2301901, nome: 'Barbalha', uf: 'CE' },
  // { codigo: 2301950, nome: 'Barreira', uf: 'CE' },
  // { codigo: 2302008, nome: 'Barro', uf: 'CE' },
  // { codigo: 2302057, nome: 'Barroquinha', uf: 'CE' },
  // { codigo: 2302107, nome: 'Baturité', uf: 'CE' },
  // { codigo: 2302206, nome: 'Beberibe', uf: 'CE' },
  // { codigo: 2302305, nome: 'Bela Cruz', uf: 'CE' },
  // { codigo: 2302404, nome: 'Boa Viagem', uf: 'CE' },
  // { codigo: 2302503, nome: 'Brejo Santo', uf: 'CE' },
  // { codigo: 2302602, nome: 'Camocim', uf: 'CE' },
  // { codigo: 2302701, nome: 'Campos Sales', uf: 'CE' },
  // { codigo: 2302800, nome: 'Canindé', uf: 'CE' },
  // { codigo: 2302909, nome: 'Capistrano', uf: 'CE' },
  // { codigo: 2303006, nome: 'Caridade', uf: 'CE' },
  // { codigo: 2303105, nome: 'Cariré', uf: 'CE' },
  // { codigo: 2303204, nome: 'Caririaçu', uf: 'CE' },
  // { codigo: 2303303, nome: 'Cariús', uf: 'CE' },
  // { codigo: 2303402, nome: 'Carnaubal', uf: 'CE' },
  // { codigo: 2303501, nome: 'Cascavel', uf: 'CE' },
  // { codigo: 2303600, nome: 'Catarina', uf: 'CE' },
  // { codigo: 2303659, nome: 'Catunda', uf: 'CE' },
  // { codigo: 2303709, nome: 'Caucaia', uf: 'CE' },
  // { codigo: 2303808, nome: 'Cedro', uf: 'CE' },
  // { codigo: 2303907, nome: 'Chaval', uf: 'CE' },
  // { codigo: 2303931, nome: 'Choró', uf: 'CE' },
  // { codigo: 2303956, nome: 'Chorozinho', uf: 'CE' },
  // { codigo: 2304004, nome: 'Coreaú', uf: 'CE' },
  // { codigo: 2304103, nome: 'Crateús', uf: 'CE' },
  // { codigo: 2304202, nome: 'Crato', uf: 'CE' },
  // { codigo: 2304236, nome: 'Croatá', uf: 'CE' },
  // { codigo: 2304251, nome: 'Cruz', uf: 'CE' },
  // { codigo: 2304269, nome: 'Deputado Irapuan Pinheiro', uf: 'CE' },
  // { codigo: 2304277, nome: 'Ererê', uf: 'CE' },
  // { codigo: 2304285, nome: 'Eusébio', uf: 'CE' },
  // { codigo: 2304301, nome: 'Farias Brito', uf: 'CE' },
  // { codigo: 2304350, nome: 'Forquilha', uf: 'CE' },
  // { codigo: 2304400, nome: 'Fortaleza', uf: 'CE' },
  // { codigo: 2304459, nome: 'Fortim', uf: 'CE' },
  // { codigo: 2304509, nome: 'Frecheirinha', uf: 'CE' },
  // { codigo: 2304608, nome: 'General Sampaio', uf: 'CE' },
  // { codigo: 2304657, nome: 'Graça', uf: 'CE' },
  // { codigo: 2304707, nome: 'Granja', uf: 'CE' },
  // { codigo: 2304806, nome: 'Granjeiro', uf: 'CE' },
  // { codigo: 2304905, nome: 'Groaíras', uf: 'CE' },
  // { codigo: 2304954, nome: 'Guaiúba', uf: 'CE' },
  // { codigo: 2305001, nome: 'Guaraciaba do Norte', uf: 'CE' },
  // { codigo: 2305100, nome: 'Guaramiranga', uf: 'CE' },
  // { codigo: 2305209, nome: 'Hidrolândia', uf: 'CE' },
  // { codigo: 2305233, nome: 'Horizonte', uf: 'CE' },
  // { codigo: 2305266, nome: 'Ibaretama', uf: 'CE' },
  // { codigo: 2305308, nome: 'Ibiapina', uf: 'CE' },
  // { codigo: 2305332, nome: 'Ibicuitinga', uf: 'CE' },
  // { codigo: 2305357, nome: 'Icapuí', uf: 'CE' },
  // { codigo: 2305407, nome: 'Icó', uf: 'CE' },
  // { codigo: 2305506, nome: 'Iguatu', uf: 'CE' },
  // { codigo: 2305605, nome: 'Independência', uf: 'CE' },
  // { codigo: 2305654, nome: 'Ipaporanga', uf: 'CE' },
  // { codigo: 2305704, nome: 'Ipaumirim', uf: 'CE' },
  // { codigo: 2305803, nome: 'Ipu', uf: 'CE' },
  // { codigo: 2305902, nome: 'Ipueiras', uf: 'CE' },
  // { codigo: 2306009, nome: 'Iracema', uf: 'CE' },
  // { codigo: 2306108, nome: 'Irauçuba', uf: 'CE' },
  // { codigo: 2306207, nome: 'Itaiçaba', uf: 'CE' },
  // { codigo: 2306256, nome: 'Itaitinga', uf: 'CE' },
  // { codigo: 2306306, nome: 'Itapagé', uf: 'CE' },
  // { codigo: 2306405, nome: 'Itapipoca', uf: 'CE' },
  // { codigo: 2306504, nome: 'Itapiúna', uf: 'CE' },
  // { codigo: 2306553, nome: 'Itarema', uf: 'CE' },
  // { codigo: 2306603, nome: 'Itatira', uf: 'CE' },
  // { codigo: 2306702, nome: 'Jaguaretama', uf: 'CE' },
  // { codigo: 2306801, nome: 'Jaguaribara', uf: 'CE' },
  // { codigo: 2306900, nome: 'Jaguaribe', uf: 'CE' },
  // { codigo: 2307007, nome: 'Jaguaruana', uf: 'CE' },
  // { codigo: 2307106, nome: 'Jardim', uf: 'CE' },
  // { codigo: 2307205, nome: 'Jati', uf: 'CE' },
  // { codigo: 2307254, nome: 'Jijoca de Jericoacoara', uf: 'CE' },
  // { codigo: 2307304, nome: 'Juazeiro do Norte', uf: 'CE' },
  // { codigo: 2307403, nome: 'Jucás', uf: 'CE' },
  // { codigo: 2307502, nome: 'Lavras da Mangabeira', uf: 'CE' },
  // { codigo: 2307601, nome: 'Limoeiro do Norte', uf: 'CE' },
  // { codigo: 2307635, nome: 'Madalena', uf: 'CE' },
  // { codigo: 2307650, nome: 'Maracanaú', uf: 'CE' },
  // { codigo: 2307700, nome: 'Maranguape', uf: 'CE' },
  // { codigo: 2307809, nome: 'Marco', uf: 'CE' },
  // { codigo: 2307908, nome: 'Martinópole', uf: 'CE' },
  // { codigo: 2308005, nome: 'Massapê', uf: 'CE' },
  // { codigo: 2308104, nome: 'Mauriti', uf: 'CE' },
  // { codigo: 2308203, nome: 'Meruoca', uf: 'CE' },
  // { codigo: 2308302, nome: 'Milagres', uf: 'CE' },
  // { codigo: 2308351, nome: 'Milhã', uf: 'CE' },
  // { codigo: 2308377, nome: 'Miraíma', uf: 'CE' },
  // { codigo: 2308401, nome: 'Missão Velha', uf: 'CE' },
  // { codigo: 2308500, nome: 'Mombaça', uf: 'CE' },
  // { codigo: 2308609, nome: 'Monsenhor Tabosa', uf: 'CE' },
  // { codigo: 2308708, nome: 'Morada Nova', uf: 'CE' },
  // { codigo: 2308807, nome: 'Moraújo', uf: 'CE' },
  // { codigo: 2308906, nome: 'Morrinhos', uf: 'CE' },
  // { codigo: 2309003, nome: 'Mucambo', uf: 'CE' },
  // { codigo: 2309102, nome: 'Mulungu', uf: 'CE' },
  // { codigo: 2309201, nome: 'Nova Olinda', uf: 'CE' },
  // { codigo: 2309300, nome: 'Nova Russas', uf: 'CE' },
  // { codigo: 2309409, nome: 'Novo Oriente', uf: 'CE' },
  // { codigo: 2309458, nome: 'Ocara', uf: 'CE' },
  // { codigo: 2309508, nome: 'Orós', uf: 'CE' },
  // { codigo: 2309607, nome: 'Pacajus', uf: 'CE' },
  // { codigo: 2309706, nome: 'Pacatuba', uf: 'CE' },
  // { codigo: 2309805, nome: 'Pacoti', uf: 'CE' },
  // { codigo: 2309904, nome: 'Pacujá', uf: 'CE' },
  // { codigo: 2310001, nome: 'Palhano', uf: 'CE' },
  // { codigo: 2310100, nome: 'Palmácia', uf: 'CE' },
  // { codigo: 2310209, nome: 'Paracuru', uf: 'CE' },
  // { codigo: 2310258, nome: 'Paraipaba', uf: 'CE' },
  // { codigo: 2310308, nome: 'Parambu', uf: 'CE' },
  // { codigo: 2310407, nome: 'Paramoti', uf: 'CE' },
  // { codigo: 2310506, nome: 'Pedra Branca', uf: 'CE' },
  // { codigo: 2310605, nome: 'Penaforte', uf: 'CE' },
  // { codigo: 2310704, nome: 'Pentecoste', uf: 'CE' },
  // { codigo: 2310803, nome: 'Pereiro', uf: 'CE' },
  // { codigo: 2310852, nome: 'Pindoretama', uf: 'CE' },
  // { codigo: 2310902, nome: 'Piquet Carneiro', uf: 'CE' },
  // { codigo: 2310951, nome: 'Pires Ferreira', uf: 'CE' },
  // { codigo: 2311009, nome: 'Poranga', uf: 'CE' },
  // { codigo: 2311108, nome: 'Porteiras', uf: 'CE' },
  // { codigo: 2311207, nome: 'Potengi', uf: 'CE' },
  // { codigo: 2311231, nome: 'Potiretama', uf: 'CE' },
  // { codigo: 2311264, nome: 'Quiterianópolis', uf: 'CE' },
  // { codigo: 2311306, nome: 'Quixadá', uf: 'CE' },
  // { codigo: 2311355, nome: 'Quixelô', uf: 'CE' },
  // { codigo: 2311405, nome: 'Quixeramobim', uf: 'CE' },
  // { codigo: 2311504, nome: 'Quixeré', uf: 'CE' },
  // { codigo: 2311603, nome: 'Redenção', uf: 'CE' },
  // { codigo: 2311702, nome: 'Reriutaba', uf: 'CE' },
  // { codigo: 2311801, nome: 'Russas', uf: 'CE' },
  // { codigo: 2311900, nome: 'Saboeiro', uf: 'CE' },
  // { codigo: 2311959, nome: 'Salitre', uf: 'CE' },
  // { codigo: 2312007, nome: 'Santana do Acaraú', uf: 'CE' },
  // { codigo: 2312106, nome: 'Santana do Cariri', uf: 'CE' },
  // { codigo: 2312205, nome: 'Santa Quitéria', uf: 'CE' },
  // { codigo: 2312304, nome: 'São Benedito', uf: 'CE' },
  // { codigo: 2312403, nome: 'São Gonçalo do Amarante', uf: 'CE' },
  // { codigo: 2312502, nome: 'São João do Jaguaribe', uf: 'CE' },
  // { codigo: 2312601, nome: 'São Luís do Curu', uf: 'CE' },
  // { codigo: 2312700, nome: 'Senador Pompeu', uf: 'CE' },
  // { codigo: 2312809, nome: 'Senador Sá', uf: 'CE' },
  // { codigo: 2312908, nome: 'Sobral', uf: 'CE' },
  // { codigo: 2313005, nome: 'Solonópole', uf: 'CE' },
  // { codigo: 2313104, nome: 'Tabuleiro do Norte', uf: 'CE' },
  // { codigo: 2313203, nome: 'Tamboril', uf: 'CE' },
  // { codigo: 2313252, nome: 'Tarrafas', uf: 'CE' },
  // { codigo: 2313302, nome: 'Tauá', uf: 'CE' },
  // { codigo: 2313351, nome: 'Tejuçuoca', uf: 'CE' },
  // { codigo: 2313401, nome: 'Tianguá', uf: 'CE' },
  // { codigo: 2313500, nome: 'Trairi', uf: 'CE' },
  // { codigo: 2313559, nome: 'Tururu', uf: 'CE' },
  // { codigo: 2313609, nome: 'Ubajara', uf: 'CE' },
  // { codigo: 2313708, nome: 'Umari', uf: 'CE' },
  // { codigo: 2313757, nome: 'Umirim', uf: 'CE' },
  // { codigo: 2313807, nome: 'Uruburetama', uf: 'CE' },
  // { codigo: 2313906, nome: 'Uruoca', uf: 'CE' },
  // { codigo: 2313955, nome: 'Varjota', uf: 'CE' },
  // { codigo: 2314003, nome: 'Várzea Alegre', uf: 'CE' },
  // { codigo: 2314102, nome: 'Viçosa do Ceará', uf: 'CE' },
  
  // Rio Grande do Sul
  { codigo: 4300034, nome: 'Aceguá', uf: 'RS' },
  { codigo: 4300059, nome: 'Água Santa', uf: 'RS' },
  { codigo: 4300109, nome: 'Agudo', uf: 'RS' },
  { codigo: 4300208, nome: 'Ajuricaba', uf: 'RS' },
  { codigo: 4300307, nome: 'Alecrim', uf: 'RS' },
  { codigo: 4300406, nome: 'Alegrete', uf: 'RS' },
  { codigo: 4300455, nome: 'Alegria', uf: 'RS' },
  { codigo: 4300471, nome: 'Almirante Tamandaré do Sul', uf: 'RS' },
  { codigo: 4300505, nome: 'Alpestre', uf: 'RS' },
  { codigo: 4300554, nome: 'Alto Alegre', uf: 'RS' },
  { codigo: 4300570, nome: 'Alto Feliz', uf: 'RS' },
  { codigo: 4300604, nome: 'Alvorada', uf: 'RS' },
  { codigo: 4300638, nome: 'Amaral Ferrador', uf: 'RS' },
  { codigo: 4300646, nome: 'Ametista do Sul', uf: 'RS' },
  { codigo: 4300661, nome: 'André da Rocha', uf: 'RS' },
  { codigo: 4300703, nome: 'Anta Gorda', uf: 'RS' },
  { codigo: 4300802, nome: 'Antônio Prado', uf: 'RS' },
  { codigo: 4300851, nome: 'Arambaré', uf: 'RS' },
  { codigo: 4300877, nome: 'Araricá', uf: 'RS' },
  { codigo: 4300901, nome: 'Aratiba', uf: 'RS' },
  { codigo: 4301008, nome: 'Arroio do Meio', uf: 'RS' },
  { codigo: 4301057, nome: 'Arroio do Sal', uf: 'RS' },
  { codigo: 4301073, nome: 'Arroio do Padre', uf: 'RS' },
  { codigo: 4301107, nome: 'Arroio dos Ratos', uf: 'RS' },
  { codigo: 4301206, nome: 'Arroio do Tigre', uf: 'RS' },
  { codigo: 4301305, nome: 'Arroio Grande', uf: 'RS' },
  { codigo: 4301404, nome: 'Arvorezinha', uf: 'RS' },
  { codigo: 4301503, nome: 'Augusto Pestana', uf: 'RS' },
  { codigo: 4301552, nome: 'Áurea', uf: 'RS' },
  { codigo: 4301602, nome: 'Bagé', uf: 'RS' },
  { codigo: 4301636, nome: 'Balneário Pinhal', uf: 'RS' },
  { codigo: 4301651, nome: 'Barão', uf: 'RS' },
  { codigo: 4301701, nome: 'Barão de Cotegipe', uf: 'RS' },
  { codigo: 4301750, nome: 'Barão do Triunfo', uf: 'RS' },
  { codigo: 4301800, nome: 'Barracão', uf: 'RS' },
  { codigo: 4301859, nome: 'Barra do Guarita', uf: 'RS' },
  { codigo: 4301875, nome: 'Barra do Quaraí', uf: 'RS' },
  { codigo: 4301909, nome: 'Barra do Ribeiro', uf: 'RS' },
  { codigo: 4301925, nome: 'Barra do Rio Azul', uf: 'RS' },
  { codigo: 4301958, nome: 'Barra Funda', uf: 'RS' },
  { codigo: 4302006, nome: 'Barros Cassal', uf: 'RS' },
  { codigo: 4302055, nome: 'Benjamin Constant do Sul', uf: 'RS' },
  { codigo: 4302105, nome: 'Bento Gonçalves', uf: 'RS' },
  { codigo: 4302154, nome: 'Boa Vista das Missões', uf: 'RS' },
  { codigo: 4302204, nome: 'Boa Vista do Buricá', uf: 'RS' },
  { codigo: 4302220, nome: 'Boa Vista do Cadeado', uf: 'RS' },
  { codigo: 4302238, nome: 'Boa Vista do Incra', uf: 'RS' },
  { codigo: 4302253, nome: 'Boa Vista do Sul', uf: 'RS' },
  { codigo: 4302303, nome: 'Bom Jesus', uf: 'RS' },
  { codigo: 4302352, nome: 'Bom Princípio', uf: 'RS' },
  { codigo: 4302378, nome: 'Bom Progresso', uf: 'RS' },
  { codigo: 4302402, nome: 'Bom Retiro do Sul', uf: 'RS' },
  { codigo: 4302451, nome: 'Boqueirão do Leão', uf: 'RS' },
  { codigo: 4302501, nome: 'Bossoroca', uf: 'RS' },
  { codigo: 4302584, nome: 'Bozano', uf: 'RS' },
  { codigo: 4302600, nome: 'Braga', uf: 'RS' },
  { codigo: 4302659, nome: 'Brochier', uf: 'RS' },
  { codigo: 4302709, nome: 'Butiá', uf: 'RS' },
  { codigo: 4302808, nome: 'Caçapava do Sul', uf: 'RS' },
  { codigo: 4302907, nome: 'Cacequi', uf: 'RS' },
  { codigo: 4303004, nome: 'Cachoeira do Sul', uf: 'RS' },
  { codigo: 4303103, nome: 'Cachoeirinha', uf: 'RS' },
  { codigo: 4303202, nome: 'Cacique Doble', uf: 'RS' },
  { codigo: 4303301, nome: 'Caibaté', uf: 'RS' },
  { codigo: 4303400, nome: 'Caiçara', uf: 'RS' },
  { codigo: 4303509, nome: 'Camaquã', uf: 'RS' },
  { codigo: 4303558, nome: 'Camargo', uf: 'RS' },
  { codigo: 4303608, nome: 'Cambará do Sul', uf: 'RS' },
  { codigo: 4303673, nome: 'Campestre da Serra', uf: 'RS' },
  { codigo: 4303707, nome: 'Campina das Missões', uf: 'RS' },
  { codigo: 4303806, nome: 'Campinas do Sul', uf: 'RS' },
  { codigo: 4303905, nome: 'Campo Bom', uf: 'RS' },
  { codigo: 4304002, nome: 'Campo Novo', uf: 'RS' },
  { codigo: 4304101, nome: 'Campos Borges', uf: 'RS' },
  { codigo: 4304200, nome: 'Candelária', uf: 'RS' },
  { codigo: 4304309, nome: 'Cândido Godói', uf: 'RS' },
  { codigo: 4304358, nome: 'Candiota', uf: 'RS' },
  { codigo: 4304408, nome: 'Canela', uf: 'RS' },
  { codigo: 4304507, nome: 'Canguçu', uf: 'RS' },
  { codigo: 4304606, nome: 'Canoas', uf: 'RS' },
  { codigo: 4304614, nome: 'Canudos do Vale', uf: 'RS' },
  { codigo: 4304622, nome: 'Capão Bonito do Sul', uf: 'RS' },
  { codigo: 4304630, nome: 'Capão da Canoa', uf: 'RS' },
  { codigo: 4304655, nome: 'Capão do Cipó', uf: 'RS' },
  { codigo: 4304663, nome: 'Capão do Leão', uf: 'RS' },
  { codigo: 4304671, nome: 'Capivari do Sul', uf: 'RS' },
  { codigo: 4304689, nome: 'Capela de Santana', uf: 'RS' },
  { codigo: 4304697, nome: 'Capitão', uf: 'RS' },
  { codigo: 4304705, nome: 'Carazinho', uf: 'RS' },
  { codigo: 4304713, nome: 'Caraá', uf: 'RS' },
  { codigo: 4304804, nome: 'Carlos Barbosa', uf: 'RS' },
  { codigo: 4304853, nome: 'Carlos Gomes', uf: 'RS' },
  { codigo: 4304903, nome: 'Casca', uf: 'RS' },
  { codigo: 4304952, nome: 'Caseiros', uf: 'RS' },
  { codigo: 4305009, nome: 'Catuípe', uf: 'RS' },
  { codigo: 4305108, nome: 'Caxias do Sul', uf: 'RS' },
  { codigo: 4305116, nome: 'Centenário', uf: 'RS' },
  { codigo: 4305124, nome: 'Cerrito', uf: 'RS' },
  { codigo: 4305132, nome: 'Cerro Branco', uf: 'RS' },
  { codigo: 4305157, nome: 'Cerro Grande', uf: 'RS' },
  { codigo: 4305173, nome: 'Cerro Grande do Sul', uf: 'RS' },
  { codigo: 4305207, nome: 'Cerro Largo', uf: 'RS' },
  { codigo: 4305306, nome: 'Chapada', uf: 'RS' },
  { codigo: 4305355, nome: 'Charqueadas', uf: 'RS' },
  { codigo: 4305371, nome: 'Charrua', uf: 'RS' },
  { codigo: 4305405, nome: 'Chiapetta', uf: 'RS' },
  { codigo: 4305439, nome: 'Chuí', uf: 'RS' },
  { codigo: 4305447, nome: 'Chuvisca', uf: 'RS' },
  { codigo: 4305454, nome: 'Cidreira', uf: 'RS' },
  { codigo: 4305504, nome: 'Ciríaco', uf: 'RS' },
  { codigo: 4305587, nome: 'Colinas', uf: 'RS' },
  { codigo: 4305603, nome: 'Colorado', uf: 'RS' },
  { codigo: 4305702, nome: 'Condor', uf: 'RS' },
  { codigo: 4305801, nome: 'Constantina', uf: 'RS' },
  { codigo: 4305835, nome: 'Coqueiro Baixo', uf: 'RS' },
  { codigo: 4305850, nome: 'Coqueiros do Sul', uf: 'RS' },
  { codigo: 4305871, nome: 'Coronel Barros', uf: 'RS' },
  { codigo: 4305900, nome: 'Coronel Bicaco', uf: 'RS' },
  { codigo: 4305934, nome: 'Coronel Pilar', uf: 'RS' },
  { codigo: 4305959, nome: 'Cotiporã', uf: 'RS' },
  { codigo: 4305975, nome: 'Coxilha', uf: 'RS' },
  { codigo: 4306007, nome: 'Crissiumal', uf: 'RS' },
  { codigo: 4306056, nome: 'Cristal', uf: 'RS' },
  { codigo: 4306072, nome: 'Cristal do Sul', uf: 'RS' },
  { codigo: 4306106, nome: 'Cruz Alta', uf: 'RS' },
  { codigo: 4306130, nome: 'Cruzaltense', uf: 'RS' },
  { codigo: 4306205, nome: 'Cruzeiro do Sul', uf: 'RS' },
  { codigo: 4306304, nome: 'David Canabarro', uf: 'RS' },
  { codigo: 4306320, nome: 'Derrubadas', uf: 'RS' },
  { codigo: 4306353, nome: 'Dezesseis de Novembro', uf: 'RS' },
  { codigo: 4306379, nome: 'Dilermando de Aguiar', uf: 'RS' },
  { codigo: 4306403, nome: 'Dois Irmãos', uf: 'RS' },
  { codigo: 4306429, nome: 'Dois Irmãos das Missões', uf: 'RS' },
  { codigo: 4306452, nome: 'Dois Lajeados', uf: 'RS' },
  { codigo: 4306502, nome: 'Dom Feliciano', uf: 'RS' },
  { codigo: 4306551, nome: 'Dom Pedro de Alcântara', uf: 'RS' },
  { codigo: 4306601, nome: 'Dom Pedrito', uf: 'RS' },
  { codigo: 4306700, nome: 'Dona Francisca', uf: 'RS' },
  { codigo: 4306734, nome: 'Doutor Maurício Cardoso', uf: 'RS' },
  { codigo: 4306759, nome: 'Doutor Ricardo', uf: 'RS' },
  { codigo: 4306767, nome: 'Eldorado do Sul', uf: 'RS' },
  { codigo: 4306809, nome: 'Encantado', uf: 'RS' },
  { codigo: 4306908, nome: 'Encruzilhada do Sul', uf: 'RS' },
  { codigo: 4306924, nome: 'Engenho Velho', uf: 'RS' },
  { codigo: 4306932, nome: 'Entre-Ijuís', uf: 'RS' },
  { codigo: 4306957, nome: 'Entre Rios do Sul', uf: 'RS' },
  { codigo: 4306973, nome: 'Erebango', uf: 'RS' },
  { codigo: 4307005, nome: 'Erechim', uf: 'RS' },
  { codigo: 4307054, nome: 'Ernestina', uf: 'RS' },
  { codigo: 4307104, nome: 'Herval', uf: 'RS' },
  { codigo: 4307203, nome: 'Erval Grande', uf: 'RS' },
  { codigo: 4307302, nome: 'Erval Seco', uf: 'RS' },
  { codigo: 4307401, nome: 'Esmeralda', uf: 'RS' },
  { codigo: 4307450, nome: 'Esperança do Sul', uf: 'RS' },
  { codigo: 4307500, nome: 'Espumoso', uf: 'RS' },
  { codigo: 4307559, nome: 'Estação', uf: 'RS' },
  { codigo: 4307609, nome: 'Estância Velha', uf: 'RS' },
  { codigo: 4307708, nome: 'Esteio', uf: 'RS' },
  { codigo: 4307807, nome: 'Estrela', uf: 'RS' },
  { codigo: 4307815, nome: 'Estrela Velha', uf: 'RS' },
  { codigo: 4307831, nome: 'Eugênio de Castro', uf: 'RS' },
  { codigo: 4307864, nome: 'Fagundes Varela', uf: 'RS' },
  { codigo: 4307906, nome: 'Farroupilha', uf: 'RS' },
  { codigo: 4308003, nome: 'Faxinal do Soturno', uf: 'RS' },
  { codigo: 4308052, nome: 'Faxinalzinho', uf: 'RS' },
  { codigo: 4308078, nome: 'Fazenda Vilanova', uf: 'RS' },
  { codigo: 4308102, nome: 'Feliz', uf: 'RS' },
  { codigo: 4308201, nome: 'Flores da Cunha', uf: 'RS' },
  { codigo: 4308250, nome: 'Floriano Peixoto', uf: 'RS' },
  { codigo: 4308300, nome: 'Fontoura Xavier', uf: 'RS' },
  { codigo: 4308409, nome: 'Formigueiro', uf: 'RS' },
  { codigo: 4308433, nome: 'Forquetinha', uf: 'RS' },
  { codigo: 4308458, nome: 'Fortaleza dos Valos', uf: 'RS' },
  { codigo: 4308508, nome: 'Frederico Westphalen', uf: 'RS' },
  { codigo: 4308607, nome: 'Garibaldi', uf: 'RS' },
  { codigo: 4308656, nome: 'Garruchos', uf: 'RS' },
  { codigo: 4308706, nome: 'Gaurama', uf: 'RS' },
  { codigo: 4308805, nome: 'General Câmara', uf: 'RS' },
  { codigo: 4308854, nome: 'Gentil', uf: 'RS' },
  { codigo: 4308904, nome: 'Getúlio Vargas', uf: 'RS' },
  { codigo: 4309001, nome: 'Giruá', uf: 'RS' },
  { codigo: 4309050, nome: 'Glorinha', uf: 'RS' },
  { codigo: 4309100, nome: 'Gramado', uf: 'RS' },
  { codigo: 4309126, nome: 'Gramado dos Loureiros', uf: 'RS' },
  { codigo: 4309159, nome: 'Gramado Xavier', uf: 'RS' },
  { codigo: 4309209, nome: 'Gravataí', uf: 'RS' },
  { codigo: 4309258, nome: 'Guabiju', uf: 'RS' },
  { codigo: 4309308, nome: 'Guaíba', uf: 'RS' },
  { codigo: 4309407, nome: 'Guaporé', uf: 'RS' },
  { codigo: 4309506, nome: 'Guarani das Missões', uf: 'RS' },
  { codigo: 4309555, nome: 'Harmonia', uf: 'RS' },
  { codigo: 4309571, nome: 'Herveiras', uf: 'RS' },
  { codigo: 4309605, nome: 'Horizontina', uf: 'RS' },
  { codigo: 4309654, nome: 'Hulha Negra', uf: 'RS' },
  { codigo: 4309704, nome: 'Humaitá', uf: 'RS' },
  { codigo: 4309753, nome: 'Ibarama', uf: 'RS' },
  { codigo: 4309803, nome: 'Ibiaçá', uf: 'RS' },
  { codigo: 4309902, nome: 'Ibiraiaras', uf: 'RS' },
  { codigo: 4309951, nome: 'Ibirapuitã', uf: 'RS' },
  { codigo: 4310009, nome: 'Ibirubá', uf: 'RS' },
  { codigo: 4310108, nome: 'Igrejinha', uf: 'RS' },
  { codigo: 4310207, nome: 'Ijuí', uf: 'RS' },
  { codigo: 4310306, nome: 'Ilópolis', uf: 'RS' },
  { codigo: 4310330, nome: 'Imbé', uf: 'RS' },
  { codigo: 4310363, nome: 'Imigrante', uf: 'RS' },
  { codigo: 4310405, nome: 'Independência', uf: 'RS' },
  { codigo: 4310413, nome: 'Inhacorá', uf: 'RS' },
  { codigo: 4310439, nome: 'Ipê', uf: 'RS' },
  { codigo: 4310462, nome: 'Ipiranga do Sul', uf: 'RS' },
  { codigo: 4310504, nome: 'Iraí', uf: 'RS' },
  { codigo: 4310538, nome: 'Itaara', uf: 'RS' },
  { codigo: 4310553, nome: 'Itacurubi', uf: 'RS' },
  { codigo: 4310579, nome: 'Itapuca', uf: 'RS' },
  { codigo: 4310603, nome: 'Itaqui', uf: 'RS' },
  { codigo: 4310652, nome: 'Itati', uf: 'RS' },
  { codigo: 4310702, nome: 'Itatiba do Sul', uf: 'RS' },
  { codigo: 4310751, nome: 'Ivorá', uf: 'RS' },
  { codigo: 4310801, nome: 'Ivoti', uf: 'RS' },
  { codigo: 4310850, nome: 'Jaboticaba', uf: 'RS' },
  { codigo: 4310876, nome: 'Jacuizinho', uf: 'RS' },
  { codigo: 4310900, nome: 'Jacutinga', uf: 'RS' },
  { codigo: 4311007, nome: 'Jaguarão', uf: 'RS' },
  { codigo: 4311106, nome: 'Jaguari', uf: 'RS' },
  { codigo: 4311122, nome: 'Jaquirana', uf: 'RS' },
  { codigo: 4311130, nome: 'Jari', uf: 'RS' },
  { codigo: 4311155, nome: 'Jóia', uf: 'RS' },
  { codigo: 4311205, nome: 'Júlio de Castilhos', uf: 'RS' },
  { codigo: 4311239, nome: 'Lagoa Bonita do Sul', uf: 'RS' },
  { codigo: 4311254, nome: 'Lagoão', uf: 'RS' },
  { codigo: 4311270, nome: 'Lagoa dos Três Cantos', uf: 'RS' },
  { codigo: 4311304, nome: 'Lagoa Vermelha', uf: 'RS' },
  { codigo: 4311403, nome: 'Lajeado', uf: 'RS' },
  { codigo: 4311429, nome: 'Lajeado do Bugre', uf: 'RS' },
  { codigo: 4311502, nome: 'Lavras do Sul', uf: 'RS' },
  { codigo: 4311601, nome: 'Liberato Salzano', uf: 'RS' },
  { codigo: 4311627, nome: 'Lindolfo Collor', uf: 'RS' },
  { codigo: 4311643, nome: 'Linha Nova', uf: 'RS' },
  { codigo: 4311700, nome: 'Machadinho', uf: 'RS' },
  { codigo: 4311718, nome: 'Maçambara', uf: 'RS' },
  { codigo: 4311734, nome: 'Mampituba', uf: 'RS' },
  { codigo: 4311759, nome: 'Manoel Viana', uf: 'RS' },
  { codigo: 4311775, nome: 'Maquiné', uf: 'RS' },
  { codigo: 4311791, nome: 'Maratá', uf: 'RS' },
  { codigo: 4311809, nome: 'Marau', uf: 'RS' },
  { codigo: 4311908, nome: 'Marcelino Ramos', uf: 'RS' },
  { codigo: 4311981, nome: 'Mariana Pimentel', uf: 'RS' },
  { codigo: 4312005, nome: 'Mariano Moro', uf: 'RS' },
  { codigo: 4312054, nome: 'Marques de Souza', uf: 'RS' },
  { codigo: 4312104, nome: 'Mata', uf: 'RS' },
  { codigo: 4312138, nome: 'Mato Castelhano', uf: 'RS' },
  { codigo: 4312153, nome: 'Mato Leitão', uf: 'RS' },
  { codigo: 4312179, nome: 'Mato Queimado', uf: 'RS' },
  { codigo: 4312203, nome: 'Maximiliano de Almeida', uf: 'RS' },
  { codigo: 4312252, nome: 'Minas do Leão', uf: 'RS' },
  { codigo: 4312302, nome: 'Miraguaí', uf: 'RS' },
  { codigo: 4312351, nome: 'Montauri', uf: 'RS' },
  { codigo: 4312377, nome: 'Monte Alegre dos Campos', uf: 'RS' },
  { codigo: 4312385, nome: 'Monte Belo do Sul', uf: 'RS' },
  { codigo: 4312401, nome: 'Montenegro', uf: 'RS' },
  { codigo: 4312427, nome: 'Mormaço', uf: 'RS' },
  { codigo: 4312443, nome: 'Morrinhos do Sul', uf: 'RS' },
  { codigo: 4312450, nome: 'Morro Redondo', uf: 'RS' },
  { codigo: 4312476, nome: 'Morro Reuter', uf: 'RS' },
  { codigo: 4312500, nome: 'Mostardas', uf: 'RS' },
  { codigo: 4312609, nome: 'Muçum', uf: 'RS' },
  { codigo: 4312617, nome: 'Muitos Capões', uf: 'RS' },
  { codigo: 4312625, nome: 'Muliterno', uf: 'RS' },
  { codigo: 4312658, nome: 'Não-Me-Toque', uf: 'RS' },
  { codigo: 4312674, nome: 'Nicolau Vergueiro', uf: 'RS' },
  { codigo: 4312708, nome: 'Nonoai', uf: 'RS' },
  { codigo: 4312757, nome: 'Nova Alvorada', uf: 'RS' },
  { codigo: 4312807, nome: 'Nova Araçá', uf: 'RS' },
  { codigo: 4312906, nome: 'Nova Bassano', uf: 'RS' },
  { codigo: 4312955, nome: 'Nova Boa Vista', uf: 'RS' },
  { codigo: 4313003, nome: 'Nova Bréscia', uf: 'RS' },
  { codigo: 4313011, nome: 'Nova Candelária', uf: 'RS' },
  { codigo: 4313037, nome: 'Nova Esperança do Sul', uf: 'RS' },
  { codigo: 4313060, nome: 'Nova Hartz', uf: 'RS' },
  { codigo: 4313086, nome: 'Nova Pádua', uf: 'RS' },
  { codigo: 4313102, nome: 'Nova Palma', uf: 'RS' },
  { codigo: 4313201, nome: 'Nova Petrópolis', uf: 'RS' },
  { codigo: 4313300, nome: 'Nova Prata', uf: 'RS' },
  { codigo: 4313334, nome: 'Nova Ramada', uf: 'RS' },
  { codigo: 4313359, nome: 'Nova Roma do Sul', uf: 'RS' },
  { codigo: 4313375, nome: 'Nova Santa Rita', uf: 'RS' },
  { codigo: 4313391, nome: 'Novo Cabrais', uf: 'RS' },
  { codigo: 4313409, nome: 'Novo Hamburgo', uf: 'RS' },
  { codigo: 4313425, nome: 'Novo Machado', uf: 'RS' },
  { codigo: 4313441, nome: 'Novo Tiradentes', uf: 'RS' },
  { codigo: 4313466, nome: 'Novo Xingu', uf: 'RS' },
  { codigo: 4313490, nome: 'Novo Barreiro', uf: 'RS' },
  { codigo: 4313508, nome: 'Osório', uf: 'RS' },
  { codigo: 4313607, nome: 'Paim Filho', uf: 'RS' },
  { codigo: 4313656, nome: 'Palmares do Sul', uf: 'RS' },
  { codigo: 4313706, nome: 'Palmeira das Missões', uf: 'RS' },
  { codigo: 4313805, nome: 'Palmitinho', uf: 'RS' },
  { codigo: 4313904, nome: 'Panambi', uf: 'RS' },
  { codigo: 4313953, nome: 'Pantano Grande', uf: 'RS' },
  { codigo: 4314001, nome: 'Paraí', uf: 'RS' },
  { codigo: 4314027, nome: 'Paraíso do Sul', uf: 'RS' },
  { codigo: 4314035, nome: 'Pareci Novo', uf: 'RS' },
  { codigo: 4314050, nome: 'Parobé', uf: 'RS' },
  { codigo: 4314068, nome: 'Passa Sete', uf: 'RS' },
  { codigo: 4314076, nome: 'Passo do Sobrado', uf: 'RS' },
  { codigo: 4314100, nome: 'Passo Fundo', uf: 'RS' },
  { codigo: 4314134, nome: 'Paulo Bento', uf: 'RS' },
  { codigo: 4314159, nome: 'Paverama', uf: 'RS' },
  { codigo: 4314175, nome: 'Pedras Altas', uf: 'RS' },
  { codigo: 4314209, nome: 'Pedro Osório', uf: 'RS' },
  { codigo: 4314308, nome: 'Pejuçara', uf: 'RS' },
  { codigo: 4314407, nome: 'Pelotas', uf: 'RS' },
  { codigo: 4314423, nome: 'Picada Café', uf: 'RS' },
  { codigo: 4314456, nome: 'Pinhal', uf: 'RS' },
  { codigo: 4314464, nome: 'Pinhal da Serra', uf: 'RS' },
  { codigo: 4314472, nome: 'Pinhal Grande', uf: 'RS' },
  { codigo: 4314498, nome: 'Pinheirinho do Vale', uf: 'RS' },
  { codigo: 4314506, nome: 'Pinheiro Machado', uf: 'RS' },
  { codigo: 4314548, nome: 'Pinto Bandeira', uf: 'RS' },
  { codigo: 4314555, nome: 'Pirapó', uf: 'RS' },
  { codigo: 4314605, nome: 'Piratini', uf: 'RS' },
  { codigo: 4314704, nome: 'Planalto', uf: 'RS' },
  { codigo: 4314753, nome: 'Poço das Antas', uf: 'RS' },
  { codigo: 4314779, nome: 'Pontão', uf: 'RS' },
  { codigo: 4314787, nome: 'Ponte Preta', uf: 'RS' },
  { codigo: 4314803, nome: 'Portão', uf: 'RS' },
  { codigo: 4314902, nome: 'Porto Alegre', uf: 'RS' },
  { codigo: 4315008, nome: 'Porto Lucena', uf: 'RS' },
  { codigo: 4315057, nome: 'Porto Mauá', uf: 'RS' },
  { codigo: 4315073, nome: 'Porto Vera Cruz', uf: 'RS' },
  { codigo: 4315107, nome: 'Porto Xavier', uf: 'RS' },
  { codigo: 4315131, nome: 'Pouso Novo', uf: 'RS' },
  { codigo: 4315149, nome: 'Presidente Lucena', uf: 'RS' },
  { codigo: 4315156, nome: 'Progresso', uf: 'RS' },
  { codigo: 4315172, nome: 'Protásio Alves', uf: 'RS' },
  { codigo: 4315206, nome: 'Putinga', uf: 'RS' },
  { codigo: 4315305, nome: 'Quaraí', uf: 'RS' },
  { codigo: 4315313, nome: 'Quatro Irmãos', uf: 'RS' },
  { codigo: 4315321, nome: 'Quevedos', uf: 'RS' },
  { codigo: 4315354, nome: 'Quinze de Novembro', uf: 'RS' },
  { codigo: 4315404, nome: 'Redentora', uf: 'RS' },
  { codigo: 4315453, nome: 'Relvado', uf: 'RS' },
  { codigo: 4315503, nome: 'Restinga Sêca', uf: 'RS' },
  { codigo: 4315552, nome: 'Rio dos Índios', uf: 'RS' },
  { codigo: 4315602, nome: 'Rio Grande', uf: 'RS' },
  { codigo: 4315701, nome: 'Rio Pardo', uf: 'RS' },
  { codigo: 4315750, nome: 'Riozinho', uf: 'RS' },
  { codigo: 4315800, nome: 'Roca Sales', uf: 'RS' },
  { codigo: 4315909, nome: 'Rodeio Bonito', uf: 'RS' },
  { codigo: 4315958, nome: 'Rolador', uf: 'RS' },
  { codigo: 4316006, nome: 'Rolante', uf: 'RS' },
  { codigo: 4316105, nome: 'Ronda Alta', uf: 'RS' },
  { codigo: 4316204, nome: 'Rondinha', uf: 'RS' },
  { codigo: 4316303, nome: 'Roque Gonzales', uf: 'RS' },
  { codigo: 4316402, nome: 'Rosário do Sul', uf: 'RS' },
  { codigo: 4316428, nome: 'Sagrada Família', uf: 'RS' },
  { codigo: 4316436, nome: 'Saldanha Marinho', uf: 'RS' },
  { codigo: 4316451, nome: 'Salto do Jacuí', uf: 'RS' },
  { codigo: 4316477, nome: 'Salvador das Missões', uf: 'RS' },
  { codigo: 4316501, nome: 'Salvador do Sul', uf: 'RS' },
  { codigo: 4316600, nome: 'Sananduva', uf: 'RS' },
  { codigo: 4316709, nome: 'Santa Bárbara do Sul', uf: 'RS' },
  { codigo: 4316733, nome: 'Santa Cecília do Sul', uf: 'RS' },
  { codigo: 4316758, nome: 'Santa Clara do Sul', uf: 'RS' },
  { codigo: 4316808, nome: 'Santa Cruz do Sul', uf: 'RS' },
  { codigo: 4316907, nome: 'Santa Maria', uf: 'RS' },
  { codigo: 4316956, nome: 'Santa Maria do Herval', uf: 'RS' },
  { codigo: 4316972, nome: 'Santa Margarida do Sul', uf: 'RS' },
  { codigo: 4317004, nome: 'Santana da Boa Vista', uf: 'RS' },
  { codigo: 4317103, nome: 'Sant Ana do Livramento', uf: 'RS' },
  { codigo: 4317202, nome: 'Santa Rosa', uf: 'RS' },
  { codigo: 4317251, nome: 'Santa Tereza', uf: 'RS' },
  { codigo: 4317301, nome: 'Santa Vitória do Palmar', uf: 'RS' },
  { codigo: 4317400, nome: 'Santiago', uf: 'RS' },
  { codigo: 4317509, nome: 'Santo Ângelo', uf: 'RS' },
  { codigo: 4317558, nome: 'Santo Antônio do Palma', uf: 'RS' },
  { codigo: 4317608, nome: 'Santo Antônio da Patrulha', uf: 'RS' },
  { codigo: 4317707, nome: 'Santo Antônio das Missões', uf: 'RS' },
  { codigo: 4317756, nome: 'Santo Antônio do Planalto', uf: 'RS' },
  { codigo: 4317806, nome: 'São Borja', uf: 'RS' },
  { codigo: 4317905, nome: 'São Francisco de Assis', uf: 'RS' },
  { codigo: 4317954, nome: 'São Francisco de Paula', uf: 'RS' },
  { codigo: 4318002, nome: 'São Gabriel', uf: 'RS' },
  { codigo: 4318051, nome: 'São José das Missões', uf: 'RS' },
  { codigo: 4318101, nome: 'São José do Herval', uf: 'RS' },
  { codigo: 4318200, nome: 'São José do Inhacorá', uf: 'RS' },
  { codigo: 4318309, nome: 'São José do Norte', uf: 'RS' },
  { codigo: 4318408, nome: 'São José do Ouro', uf: 'RS' },
  { codigo: 4318424, nome: 'São José do Sul', uf: 'RS' },
  { codigo: 4318432, nome: 'São José dos Ausentes', uf: 'RS' },
  { codigo: 4318440, nome: 'São Leopoldo', uf: 'RS' },
  { codigo: 4318457, nome: 'São Lourenço do Sul', uf: 'RS' },
  { codigo: 4318465, nome: 'São Luiz Gonzaga', uf: 'RS' },
  { codigo: 4318481, nome: 'São Miguel das Missões', uf: 'RS' },
  { codigo: 4318499, nome: 'São Nicolau', uf: 'RS' },
  { codigo: 4318507, nome: 'São Paulo das Missões', uf: 'RS' },
  { codigo: 4318606, nome: 'São Pedro da Serra', uf: 'RS' },
  { codigo: 4318614, nome: 'São Pedro das Missões', uf: 'RS' },
  { codigo: 4318622, nome: 'São Pedro do Butiá', uf: 'RS' },
  { codigo: 4318705, nome: 'São Pedro do Sul', uf: 'RS' },
  { codigo: 4318804, nome: 'São Sebastião do Caí', uf: 'RS' },
  { codigo: 4318903, nome: 'São Sepé', uf: 'RS' },
  { codigo: 4319000, nome: 'São Valentim', uf: 'RS' },
  { codigo: 4319109, nome: 'São Valentim do Sul', uf: 'RS' },
  { codigo: 4319125, nome: 'São Valério do Sul', uf: 'RS' },
  { codigo: 4319158, nome: 'São Vendelino', uf: 'RS' },
  { codigo: 4319208, nome: 'São Vicente do Sul', uf: 'RS' },
  { codigo: 4319307, nome: 'Sapiranga', uf: 'RS' },
  { codigo: 4319356, nome: 'Sapucaia do Sul', uf: 'RS' },
  { codigo: 4319364, nome: 'Sarandi', uf: 'RS' },
  { codigo: 4319372, nome: 'Seberi', uf: 'RS' },
  { codigo: 4319406, nome: 'Sede Nova', uf: 'RS' },
  { codigo: 4319505, nome: 'Segredo', uf: 'RS' },
  { codigo: 4319604, nome: 'Selbach', uf: 'RS' },
  { codigo: 4319703, nome: 'Senador Salgado Filho', uf: 'RS' },
  { codigo: 4319711, nome: 'Sentinela do Sul', uf: 'RS' },
  { codigo: 4319737, nome: 'Serafina Corrêa', uf: 'RS' },
  { codigo: 4319752, nome: 'Sério', uf: 'RS' },
  { codigo: 4319802, nome: 'Sertão', uf: 'RS' },
  { codigo: 4319901, nome: 'Sertão Santana', uf: 'RS' },
  { codigo: 4320008, nome: 'Sete de Setembro', uf: 'RS' },
  { codigo: 4320107, nome: 'Severiano de Almeida', uf: 'RS' },
  { codigo: 4320206, nome: 'Silveira Martins', uf: 'RS' },
  { codigo: 4320230, nome: 'Sinimbu', uf: 'RS' },
  { codigo: 4320263, nome: 'Sobradinho', uf: 'RS' },
  { codigo: 4320305, nome: 'Soledade', uf: 'RS' },
  { codigo: 4320321, nome: 'Tabaí', uf: 'RS' },
  { codigo: 4320354, nome: 'Tapejara', uf: 'RS' },
  { codigo: 4320404, nome: 'Tapera', uf: 'RS' },
  { codigo: 4320453, nome: 'Tapes', uf: 'RS' },
  { codigo: 4320503, nome: 'Taquara', uf: 'RS' },
  { codigo: 4320552, nome: 'Taquari', uf: 'RS' },
  { codigo: 4320578, nome: 'Taquaruçu do Sul', uf: 'RS' },
  { codigo: 4320602, nome: 'Tavares', uf: 'RS' },
  { codigo: 4320651, nome: 'Tenente Portela', uf: 'RS' },
  { codigo: 4320677, nome: 'Terra de Areia', uf: 'RS' },
  { codigo: 4320701, nome: 'Teutônia', uf: 'RS' },
  { codigo: 4320800, nome: 'Tiradentes do Sul', uf: 'RS' },
  { codigo: 4320859, nome: 'Toropi', uf: 'RS' },
  { codigo: 4320909, nome: 'Torres', uf: 'RS' },
  { codigo: 4321006, nome: 'Tramandaí', uf: 'RS' },
  { codigo: 4321105, nome: 'Travesseiro', uf: 'RS' },
  { codigo: 4321204, nome: 'Três Arroios', uf: 'RS' },
  { codigo: 4321303, nome: 'Três Cachoeiras', uf: 'RS' },
  { codigo: 4321329, nome: 'Três Coroas', uf: 'RS' },
  { codigo: 4321352, nome: 'Três de Maio', uf: 'RS' },
  { codigo: 4321402, nome: 'Três Forquilhas', uf: 'RS' },
  { codigo: 4321436, nome: 'Três Palmeiras', uf: 'RS' },
  { codigo: 4321451, nome: 'Três Passos', uf: 'RS' },
  { codigo: 4321469, nome: 'Trindade do Sul', uf: 'RS' },
  { codigo: 4321477, nome: 'Triunfo', uf: 'RS' },
  { codigo: 4321493, nome: 'Tucunduva', uf: 'RS' },
  { codigo: 4321501, nome: 'Tunas', uf: 'RS' },
  { codigo: 4321600, nome: 'Tupanci do Sul', uf: 'RS' },
  { codigo: 4321626, nome: 'Tupandi', uf: 'RS' },
  { codigo: 4321634, nome: 'Tuparendi', uf: 'RS' },
  { codigo: 4321667, nome: 'Turuçu', uf: 'RS' },
  { codigo: 4321709, nome: 'Ubiretama', uf: 'RS' },
  { codigo: 4321808, nome: 'União da Serra', uf: 'RS' },
  { codigo: 4321832, nome: 'Unistalda', uf: 'RS' },
  { codigo: 4321857, nome: 'Uruguaiana', uf: 'RS' },
  { codigo: 4321907, nome: 'Vacaria', uf: 'RS' },
  { codigo: 4321956, nome: 'Vale Verde', uf: 'RS' },
  { codigo: 4322004, nome: 'Vale do Sol', uf: 'RS' },
  { codigo: 4322103, nome: 'Vale Real', uf: 'RS' },
  { codigo: 4322152, nome: 'Vanini', uf: 'RS' },
  { codigo: 4322186, nome: 'Vera Cruz', uf: 'RS' },
  { codigo: 4322202, nome: 'Veranópolis', uf: 'RS' },
  { codigo: 4322251, nome: 'Vespasiano Corrêa', uf: 'RS' },
  { codigo: 4322301, nome: 'Viadutos', uf: 'RS' },
  { codigo: 4322327, nome: 'Viamão', uf: 'RS' },
  { codigo: 4322343, nome: 'Vicente Dutra', uf: 'RS' },
  { codigo: 4322350, nome: 'Victor Graeff', uf: 'RS' },
  { codigo: 4322376, nome: 'Vila Flores', uf: 'RS' },
  { codigo: 4322400, nome: 'Vila Lângaro', uf: 'RS' },
  { codigo: 4322509, nome: 'Vista Alegre', uf: 'RS' },
  { codigo: 4322533, nome: 'Vista Alegre do Prata', uf: 'RS' },
  { codigo: 4322541, nome: 'Vista Gaúcha', uf: 'RS' },
  { codigo: 4322608, nome: 'Vitória das Missões', uf: 'RS' },
  { codigo: 4322707, nome: 'Westfália', uf: 'RS' },
  { codigo: 4322806, nome: 'Xangri-lá', uf: 'RS' },
];

